export default __webpack_public_path__ + "static/media/bigBanner.b0620999.svg";